module.exports = __webpack_public_path__ + "img/bsc-logo.cbfe931f.svg";